import {create} from "zustand";
import {LoginRequestDto} from "@/@types/auth.types.ts";

type FormStep = "login" | "register" | "resetPassword";

type AuthFormStore = {
    formStep: FormStep;
    setFormStep: (step: FormStep) => void;
    loginRequest: LoginRequestDto;
    setLoginRequest: (loginRequest: LoginRequestDto) => void;
    twoFactorToken?: string;
    setTwoFactorToken: (token: string) => void;
    email?: string;
    setEmail: (email: string) => void;
}

export const useAuthForm = create<AuthFormStore>((set) => ({
    loginRequest: {
        userName: "",
        password: "",
    },
    setLoginRequest: (loginRequest: LoginRequestDto) => set({loginRequest}),
    formStep: "login",
    setFormStep: (step) => set({formStep: step}),
    twoFactorToken: undefined,
    setTwoFactorToken: (token: string) => set({twoFactorToken: token}),
    email: undefined,
    setEmail: (email: string) => set({email}),
}));